import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

// component
import { Table } from '../components/commons/table';

// reducers
import { listNewPartnerApplicant } from '../stores/applicant.partners';

const columnDefs = (navigation) => {
  return {
    default: [
      {
        name: 'Applicant',
        style: 'py-4 pl-4 text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { name } = row.individual;
          return (
            <td>
              <Link to={`/partners/details/${row.account_id}/registration`}>
                <h3 className='px-4 text-sm text-secondary-500 font-bold underline hover:cursor-pointer'>{name}</h3>
              </Link>
            </td>

          )
        },
      },
      {
        name: 'Contact Information',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { email, phone_number } = row.individual;
          return (
            <td className="py-4">
              <h3 className='text-sm text-slate-600 font-normal'>{email}</h3>
              <h3 className='text-sm text-slate-600 font-normal'>{phone_number}</h3>
            </td>
          )
        },
      },
      {
        name: 'Region',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { municipality, state } = row.application_location;
          return (
            <td className="py-4">
              <p className='text-sm text-slate-600 font-normal'>{municipality}, {state}</p>
            </td>
          )
        },
      },
      {
        name: 'Electrical Wiring',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { electrical_wiring: competency } = row.electrical_competency;
          return (
            <td className="py-4">
              {competency.not_applicable &&
                <span className="inline-flex items-center rounded-md bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">
                  Not certified
                </span>
              }
              {!competency.not_applicable &&
                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  {competency.highest_level}
                </span>
              }
            </td>
          )
        },
      },
      {
        name: 'Electrical Chargeman',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          const { chargeman: competency } = row.electrical_competency;
          return (
            <td className="py-4">
              {competency.not_applicable &&
                <span className="inline-flex items-center rounded-md bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10">
                  Not certified
                </span>
              }
              {!competency.not_applicable &&
                <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">
                  {competency.highest_level}
                </span>
              }
            </td>
          )
        },
      },
      {
        name: 'Date Application',
        style: 'text-left text-sm font-semibold text-slate-800',
        row: (row) => {
          return (
            <td className="py-4">
              <p className='text-sm text-slate-600 font-normal'>{new Date(row.modified).toLocaleDateString()}</p>
              <p className='text-xs text-slate-700 font-normal'>({moment(row.modified).fromNow()})</p>
            </td>
          )
        },
      },
    ],
  }
}

export const TablePartnersApplication = ({ data = [] }) => {

  // hooks
  const dispatch = useDispatch();
  const { lists = [], next_token } = useSelector(context => context.applicantPartners);
  const navigation = useNavigate();

  const loaddata = async (nextToken = null) => {
    try {
      const res = await dispatch(listNewPartnerApplicant({
        next_token: nextToken,
      })).unwrap();
      console.log('tables.partners.application@loaddata', 'res', res);
    } catch (err) {
      console.error('tables.partners.application@loaddata', err);
      toast.error(err.message);
    }
  }

  useEffect(() => {
    loaddata();
  }, []);

  return (
    <div className='mt-8'>
      <div className='mt-4 rounded-md shadow-md'>
        <Table
          className='rounded-md'
          data={lists}
          columnDefs={columnDefs(navigation)}
          hasMorePages={next_token ? true : false}
          onLoadMore={() => loaddata(next_token)}
        />
      </div>
    </div>
  )
}